
import * as constants from "../../assets/constants";
import {baseApi} from "../BaseApi";



class KlientsApi extends baseApi {


    getOne = async (id) => {

        return await this.get(`?app=klients&act=getOneKlientjson&id=${id}`)

    }

     getList = async (data) => {

        return await this.post('?app=klients&act=getKlientsjson', data)

    }



     save = async (data) => {
        return await this.post('?app=klients&act=save', {data:JSON.stringify(data)})

    }
    checkINNExist = async (INN) => {
        return await this.post('?app=klients&act=checkINNExist', {INN: INN})

    }


    deleteKlient = async (id) => {
        return await this.post('?app=klients&act=setDeleted', {id})

    }

}

export default new KlientsApi(constants.DEBUG?constants.base_url_stage:constants.base_url_prod);